/**
 * Move the item at `fromIndex` to `toIndex`, shifting everything between.
 * Used by the bundle editor's item list — both the HTML5 drag-and-drop
 * handlers and the ▲▼ keyboard/touch fallback buttons call this so the two
 * interaction paths can never disagree about the resulting order.
 *
 * Returns a new array; out-of-range indices are clamped rather than thrown,
 * and a no-op move (fromIndex === toIndex, or either index off the array)
 * returns an array equal-by-value to the input.
 */
export function reorder<T>(items: T[], fromIndex: number, toIndex: number): T[] {
  if (items.length === 0) return items.slice();
  const from = clamp(fromIndex, 0, items.length - 1);
  const to = clamp(toIndex, 0, items.length - 1);
  if (from === to) return items.slice();
  const next = items.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}

function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}
